import React, { useState } from "react";
import { ShowItem } from "../common/ShowItem";
import { getImageFileFetch } from "../../features/action/fetchImage";
import { useDispatch, useSelector } from "react-redux";
import { FaPrint } from "react-icons/fa6";
import { DateTo, MembersBlock } from "./mainBloks";
import { DateFrom } from "./mainBloks";
import { putUpdateHpFileFetch } from "../../features/action/fetchHp";
import { img, imgFalse, so, soFalse } from "../../util/icon";
import { fetchOrderFile } from "../../features/action/fetchStatusFile";
import { setHtmlContent } from "../../features/redux/statusFileSlice";
import { ShowOrder } from "../common/ShowOrder";

export const Strip = ({ i, color }) => {
  const { image, loadingImage } = useSelector((state) => state.imageFile);
  const [showItems, setShowItems] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const [showOrder, setShowOrder] = useState(false);
  const dispatch = useDispatch();
  
  const handleOpenOrder = (e, numOrder) => {
    e.stopPropagation();
    dispatch(setHtmlContent(null));
    dispatch(fetchOrderFile(numOrder));
    setShowOrder(true);
  };

  const handleClickPrint = async (id, folderFabric, fileName) => {
    dispatch(putUpdateHpFileFetch(id, folderFabric, fileName));
  };

  const handleOpenImage = (key, url) => {
    setShowItems(key);
    dispatch(getImageFileFetch(url));
  };
  return (
    <React.Fragment>
      {i.item.map((a, k1) => (
        <div
          className="flex flex-row h-[64px] w-[100%] mb-1 text-center rounded-[10px] bg-white border-solid border-2 border-[#dbdbdb] mx-auto"
          key={k1}
        >
          {DateFrom(a.toDate, color)}
          {DateTo(a.date)}
          {MembersBlock(a.manager, a.designer)}

          <div className="w-[19.19%]  content-center">
            <div
              className="relative w-full h-[62px] transition-transform duration-500 cursor-pointer"
              style={{
                transformStyle: "preserve-3d",
                transform: isFlipped[k1] ? "rotateX(180deg)" : "rotateX(0deg)",
              }}
              onClick={() => setIsFlipped(prev => ({ ...prev, [k1]: !prev[k1] }))}
            >
            {/* Передняя сторона - номер заказа */}
            <div
              className={`absolute w-full h-[62px] flex items-center justify-center bg-[#739D00]`}
              style={{ backfaceVisibility: "hidden" }}
            >
              <div className="flex flex-row justify-center items-center ">
                <p className="text-[2.3vw] font-rubik font-black  text-white">
                  {a.fileName.slice(0, 4)}
                </p>
              </div>
            </div>
            {/* Задняя сторона - текст клиента */}
            <div
              className={`absolute w-[100%] h-full flex bg-[#739D00] text-left items-center justify-center `}
              style={{
                backfaceVisibility: "hidden",
                transform: "rotateX(180deg)",
              }}
            >
              <div className="flex w-full h-full justify-evenly content-center items-center">
                {/* ---------------------------------------Show HTML SO-------------------------------------------------- */}
                <button
                  className="text-[2vw] w-[11%] content-center "
                  onClick={(e) => {
                    e.stopPropagation();
                    if (a.order) handleOpenOrder(e, a.order);
                  }}
                >
                  {a.order ? so : soFalse}
                </button>

                {/* ---------------------------------------Image-------------------------------------------------- */}
                {
                  <button
                    className="text-[2vw]  w-[11%] content-center "
                    onClick={(e) => {
                      e.stopPropagation();
                      if (a.image) handleOpenImage(k1, a.image);
                    }}
                  >
                    {a.image ? img : imgFalse}
                  </button>
                }
              </div>
            </div>
            </div>
          </div>
          {/* ----------------------------------------Show IMG----------------------------------------------------- */}
          {showItems === k1 && (
            <ShowItem
              url={image}
              setShowItems={setShowItems}
              loadingImage={loadingImage}
            />
          )}
          {showOrder && <ShowOrder setShowOrder={setShowOrder} />}
          {/* --------------------------------------------------------------------------------------------- */}
          <div className="w-[31.57%] content-center">
            <p className="text-[1vw] font-rubik font-light text-xl text-black">
              {a.fileName}
            </p>
          </div>
          {/* -----------------------------------------print update---------------------------------------------------- */}
          <button
            className=" w-[10.10%] bg-[#739D00] content-center rounded-r-[8px] hover:bg-[#FF3D00] "
            onClick={() => handleClickPrint(a._id, i.folderFabric, a.fileName)}
          >
            <FaPrint className="text-white text-[2vw]" />
          </button>
          {/* --------------------------------------------------------------------------------------------- */}
        </div>
      ))}
    </React.Fragment>
  );
};
